import { Directive } from '@angular/core';
import { MAT_SELECT_CONFIG } from '@angular/material/select';

@Directive({
  selector: '[fwOverlayPanelClass]',
  providers: [{
    provide: MAT_SELECT_CONFIG,
    useValue: {
      overlayPanelClass: 'max-height',
    },
  }],
})
export class FwOverlayPanelClassDirective {}
